import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface CopyIconProps extends SvgIconProps {}

export const CopyIcon = (props: CopyIconProps): ReactElement => {
  return (
    <SvgIcon
      style={{ fontSize: '1em' }}
      {...props}
      width="31.5"
      height="31.501"
      viewBox="0 0 31.5 31.501"
    >
      <g transform="translate(0.75 0.75)">
        <path
          d="M12.737,9H27.291a3.737,3.737,0,0,1,3.737,3.737V27.291a3.737,3.737,0,0,1-3.737,3.737H12.737A3.737,3.737,0,0,1,9,27.291V12.737A3.737,3.737,0,0,1,12.737,9Z"
          transform="translate(-1.028 -1.027)"
          fill="#23305f"
          stroke="#23305f"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M25.37,8.62,25.4,7.046a3.682,3.682,0,0,0-3.672-3.672H7.571a4.208,4.208,0,0,0-4.2,4.2V21.731A3.682,3.682,0,0,0,7.047,25.4H8.621"
          transform="translate(-3.375 -3.374)"
          fill="none"
          stroke="#23305f"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </SvgIcon>
  );
};
